import Vue from 'vue';
export default {
  data() {
    return {
      tempUserBrithDate: '',
      showUserBrithDate: false,
      tempUserExpireDate: '',
      showUserExpireDate: false,
      disabelConfirm: false,
      maxDate: '',
      minDate: '1900/05/20',
      expireMaxDate: '',
      expireMinDate: '',
    };
  },
  methods: {
    userBrithDateChange: function () {
      if (this.editUserInfo.birthDate) {
        this.tempUserBrithDate = Vue.moment(this.editUserInfo.birthDate).format('jYYYY-jMM-jDD');
      }
    },
    userExpireDateChange: function () {
      if (this.editUserInfo.expireDate) {
        this.tempUserExpireDate = Vue.moment(this.editUserInfo.expireDate).format('jYYYY-jMM-jDD');
      }
    },
    makeDataReady: function (info) {
      this.editUserInfo.firstName = info.firstName ? info.firstName : '';
      this.editUserInfo.lastName = info.lastName ? info.lastName : '';
      this.editUserInfo.userName = info.userName ? info.userName : '';
      this.editUserInfo.phoneNumber = info.phoneNumber ? info.phoneNumber : '';
      this.editUserInfo.nationalCode = info.nationalCode ? info.nationalCode : '';
      //this.editUserInfo.gender = (info.gender) ? info.gender : 0;
      this.editUserInfo.birthDate = info.birthDate ? info.birthDate : '';
      this.editUserInfo.address = info.address ? info.address : '';
      this.editUserInfo.educationDegreeId = info.educationDegreeId ? info.educationDegreeId : null;
      this.editUserInfo.expireDate = info.expireDate ? info.expireDate : '';
      this.editUserInfo.emailAddress = info.emailAddress ? info.emailAddress : '';
      this.editUserInfo.usePasswordPolicy = info.usePasswordPolicy ? info.usePasswordPolicy : false;
      this.editUserInfo.forceChangePassword = info.forceChangePassword
        ? info.forceChangePassword
        : false;
      this.editUserInfo.forceTwoStepAuthentication = info.forceTwoStepAuthentication
        ? info.forceTwoStepAuthentication
        : false;
      if (info.gender == 0) {
        this.editUserInfo.gender = 0;
      } else if (info.gender == 1) {
        this.editUserInfo.gender = 1;
      } else {
        this.editUserInfo.gender = null;
      }
      this.editUserInfo.id = Number(this.userId);
      this.userBrithDateChange();
      this.userExpireDateChange();
    },
    checkValdition: function () {
      if (!this.editUserInfo.firstName) {
        this.snackText = 'لطفا نام را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.editUserInfo.lastName) {
        this.snackText = 'لطفا نام خانوادگی را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.editUserInfo.nationalCode) {
        this.snackText = 'لطفا کد ملی را وارد نمایید.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.editUserInfo.nationalCode.length < 10) {
        this.snackText = 'کد ملی وارد شده معتبر نیست.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.editUserInfo.phoneNumber) {
        if (this.editUserInfo.phoneNumber.length < 11) {
          this.snackText = 'شماره همراه وارد شده معتبر نیست.';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
      }
      this.showConfirmDialogFunction();
    },
    showConfirmDialogFunction: function () {
      this.$refs.confirm.title = 'ویرایش کاربر';
      this.$refs.confirm.text = 'از ویرایش کاربر اطمینان دارید؟';
      this.$refs.confirm.showConfirmDialog = true;
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      this.disabelConfirm = true;
      this.EditUserFunction();
    },
    confirmDialogCancelFunction: function () {
      this.$refs.confirm.showConfirmDialog = false;
      this.disabelConfirm = false;
    },
    clearBirthDate: function () {
      this.showUserBrithDate = false;
      this.tempUserBrithDate = '';
      this.editUserInfo.birthDate = '';
    },
    clearExpireDate: function () {
      this.showUserExpireDate = false;
      this.tempUserExpireDate = '';
      this.editUserInfo.expireDate = '';
    },
  },
};
